/* Dutch Local Food — categoriepagina: filters, prijs, paginering */
(function () {
  var LANG = ((document.documentElement.getAttribute('lang') || 'nl').slice(0, 2)).toLowerCase();
  var T = {
    nl: { one: 'product', many: 'producten', prev: 'Vorige pagina', next: 'Volgende pagina' },
    en: { one: 'product', many: 'products', prev: 'Previous page', next: 'Next page' },
    de: { one: 'Produkt', many: 'Produkte', prev: 'Vorherige Seite', next: 'Nächste Seite' }
  }[LANG] || { one: 'product', many: 'producten', prev: 'Vorige pagina', next: 'Volgende pagina' };

  function init(root) {
    if (root.dataset.dlfcReady) return;
    root.dataset.dlfcReady = '1';

    var grid = root.querySelector('.dlfc-grid');
    var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll('.dlfc-card')) : [];
    var countEl = root.querySelector('[data-dlfc-count]');
    var emptyEl = root.querySelector('[data-dlfc-empty]');
    var pager = root.querySelector('[data-dlfc-pager]');
    var perPage = pager ? parseInt(pager.dataset.perPage, 10) || 24 : 24;
    var page = 1;

    var form = root.querySelector('[data-dlfc-filter-form]');
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); });

    var price = root.querySelector('[data-dlfc-price]');
    var pMin = 0, pMax = Infinity, pLo, pHi, minR, maxR;
    if (price) {
      pLo = parseFloat(price.dataset.min) || 0;
      pHi = parseFloat(price.dataset.max) || 1;
      minR = price.querySelector('[data-dlfc-price-min]');
      maxR = price.querySelector('[data-dlfc-price-max]');
      var minL = price.querySelector('[data-dlfc-price-min-label]');
      var maxL = price.querySelector('[data-dlfc-price-max-label]');
      var fill = price.querySelector('[data-dlfc-price-fill]');
      var paint = function () {
        var a = Math.min(+minR.value, +maxR.value);
        var b = Math.max(+minR.value, +maxR.value);
        minL.textContent = a;
        maxL.textContent = b;
        var span = pHi - pLo || 1;
        fill.style.left = ((a - pLo) / span) * 100 + '%';
        fill.style.right = 100 - ((b - pLo) / span) * 100 + '%';
        pMin = a;
        pMax = b;
      };
      price.resetSlider = function () { minR.value = pLo; maxR.value = pHi; paint(); };
      [minR, maxR].forEach(function (r) {
        r.addEventListener('input', function () { paint(); page = 1; apply(); });
      });
      paint();
      pMin = pLo;
      pMax = pHi;
    }

    var boxes = Array.prototype.slice.call(root.querySelectorAll('[data-dlfc-filter]'));
    boxes.forEach(function (b) {
      b.addEventListener('change', function () { page = 1; apply(); });
    });

    function selections() {
      var groups = [];
      root.querySelectorAll('[data-dlfc-group]').forEach(function (g) {
        var vals = [];
        g.querySelectorAll('[data-dlfc-filter]:checked').forEach(function (i) { vals.push(i.value); });
        if (vals.length) groups.push({ type: g.dataset.dlfcGroup, values: vals });
      });
      return groups;
    }

    function matches(card, groups) {
      var pr = parseFloat(card.dataset.price) || 0;
      if (price && (pr < pMin || pr > pMax + 0.001)) return false;
      for (var i = 0; i < groups.length; i++) {
        var g = groups[i], ok = false;
        for (var j = 0; j < g.values.length; j++) {
          var v = g.values[j];
          if (g.type === 'flags') {
            if (v === 'available' && card.dataset.available === 'true') ok = true;
            if (v === 'sale' && card.dataset.sale === 'true') ok = true;
          } else if ((card.dataset.tags || '').indexOf('|' + v + '|') > -1) {
            ok = true;
          }
          if (ok) break;
        }
        if (!ok) return false;
      }
      return true;
    }

    function label(n) { return n + ' ' + (n === 1 ? T.one : T.many); }

    function renderPager(total) {
      if (!pager) return;
      var pages = Math.ceil(total / perPage);
      pager.innerHTML = '';
      if (pages <= 1) { pager.hidden = true; return; }
      pager.hidden = false;
      function btn(text, target, opts) {
        var el = document.createElement(opts && opts.active ? 'span' : 'button');
        el.className = 'dlfc-page' + (opts && opts.active ? ' is-active' : '');
        el.textContent = text;
        if (opts && opts.aria) el.setAttribute('aria-label', opts.aria);
        if (opts && opts.active) {
          el.setAttribute('aria-current', 'page');
        } else {
          el.type = 'button';
          el.addEventListener('click', function () {
            page = target;
            apply();
            var top = root.querySelector('.dlfc-results').getBoundingClientRect().top + window.pageYOffset - 120;
            window.scrollTo({ top: top, behavior: 'smooth' });
          });
        }
        pager.appendChild(el);
      }
      if (page > 1) btn('←', page - 1, { aria: T.prev });
      for (var p = 1; p <= pages; p++) btn(String(p), p, { active: p === page });
      if (page < pages) btn('→', page + 1, { aria: T.next });
    }

    function apply() {
      var groups = selections();
      var visible = cards.filter(function (c) { return matches(c, groups); });
      var pages = Math.max(1, Math.ceil(visible.length / perPage));
      if (page > pages) page = pages;
      var from = (page - 1) * perPage, to = from + perPage;
      cards.forEach(function (c) { c.hidden = true; });
      visible.forEach(function (c, i) { c.hidden = i < from || i >= to; });
      if (countEl) countEl.textContent = label(visible.length);
      if (emptyEl) emptyEl.hidden = visible.length > 0 || cards.length === 0;
      if (grid) grid.hidden = visible.length === 0 && cards.length > 0;
      renderPager(visible.length);
    }

    root.querySelectorAll('[data-dlfc-clear]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        boxes.forEach(function (x) { x.checked = false; });
        if (price) price.resetSlider();
        page = 1;
        apply();
      });
    });

    root.querySelectorAll('[data-dlfc-category]').forEach(function (el) {
      el.addEventListener('change', function () {
        if (el.checked) window.location.href = el.value;
      });
    });

    var sort = root.querySelector('[data-dlfc-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', sort.value);
        u.searchParams.delete('page');
        window.location.href = u.toString();
      });
    }

    var toggle = root.querySelector('[data-dlfc-filter-toggle]');
    var sidebar = root.querySelector('[data-dlfc-sidebar]');
    if (toggle && sidebar) {
      toggle.addEventListener('click', function () {
        var open = sidebar.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    var KEY = 'dlfc-saved';
    var saved = [];
    try { saved = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}
    root.querySelectorAll('[data-dlfc-save]').forEach(function (btn) {
      var handle = btn.dataset.dlfcSave;
      function render() {
        var on = saved.indexOf(handle) > -1;
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.firstElementChild.textContent = on ? '♥' : '♡';
      }
      btn.addEventListener('click', function () {
        var i = saved.indexOf(handle);
        if (i > -1) saved.splice(i, 1); else saved.push(handle);
        try { localStorage.setItem(KEY, JSON.stringify(saved)); } catch (e) {}
        render();
      });
      render();
    });

    apply();
  }

  function boot() {
    document.querySelectorAll('.dlfc-collection').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();